/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  UploadFileBody,
  UploadFileResponse
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Uploads a file to S3 for data transformation processing.
 * Validates that the user's organization matches either the manufacturer or distributor.
 * Validates that the partner organization exists and has a relationship with the user's organization.
 * @summary Upload a data transformation file (SPA, Pricesheet, POSTransactions, ClaimResponse).
 */
export const uploadFile = (
    uploadFileBody: UploadFileBody,
 options?: SecondParameter<typeof apiRequest<UploadFileResponse>>,) => {const formData = new FormData();
if(uploadFileBody.partnerOrganizationId !== undefined) {
 formData.append(`partnerOrganizationId`, uploadFileBody.partnerOrganizationId);
 }
if(uploadFileBody.documentType !== undefined) {
 formData.append(`documentType`, uploadFileBody.documentType);
 }
if(uploadFileBody.userOrgType !== undefined) {
 formData.append(`userOrgType`, uploadFileBody.userOrgType);
 }
if(uploadFileBody.isHeadless !== undefined) {
 formData.append(`isHeadless`, uploadFileBody.isHeadless.toString())
 }
formData.append(`file`, uploadFileBody.file);

      return apiRequest<UploadFileResponse>(
      {url: `/data-transformation/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  export type UploadFileResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>
